module.exports = (__parcel__import__("hAvwt")).then(() => parcelRequire('g36Vt'));